export var Session = {
    SCROLL_POSITION: 'cs-scroll-position'
};
